/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrincipalOccupationResponseDto
 */
export interface PrincipalOccupationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PrincipalOccupationResponseDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrincipalOccupationResponseDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the PrincipalOccupationResponseDto interface.
 */
export function instanceOfPrincipalOccupationResponseDto(value: object): value is PrincipalOccupationResponseDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function PrincipalOccupationResponseDtoFromJSON(json: any): PrincipalOccupationResponseDto {
    return PrincipalOccupationResponseDtoFromJSONTyped(json, false);
}

export function PrincipalOccupationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrincipalOccupationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'isActive': json['isActive'],
    };
}

export function PrincipalOccupationResponseDtoToJSON(json: any): PrincipalOccupationResponseDto {
    return PrincipalOccupationResponseDtoToJSONTyped(json, false);
}

export function PrincipalOccupationResponseDtoToJSONTyped(value?: PrincipalOccupationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'isActive': value['isActive'],
    };
}

